import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || 'your-mixpanel-token-here';

mixpanel.init(MIXPANEL_TOKEN, {
  debug: process.env.NODE_ENV === 'development',
  track_pageview: true,
  persistence: 'localStorage'
});

// Helper functions for tracking
export const track = (event: string, properties?: Record<string, any>) => {
  try {
    mixpanel.track(event, properties);
  } catch (error) {
    console.error('Mixpanel tracking error:', error);
  }
};

export const identify = (userId: string, userProperties?: Record<string, any>) => {
  try {
    mixpanel.identify(userId);
    if (userProperties) {
      mixpanel.people.set(userProperties);
    }
  } catch (error) {
    console.error('Mixpanel identify error:', error);
  }
};

export const setUserProperties = (properties: Record<string, any>) => {
  try {
    mixpanel.people.set(properties);
  } catch (error) {
    console.error('Mixpanel set user properties error:', error);
  }
};

export const trackPageView = (pageName: string, properties?: Record<string, any>) => {
  try {
    mixpanel.track('Page Viewed', {
      page_name: pageName,
      ...properties
    });
  } catch (error) {
    console.error('Mixpanel page view tracking error:', error);
  }
};

export const trackButtonClick = (buttonName: string, properties?: Record<string, any>) => {
  try {
    mixpanel.track('Button Clicked', {
      button_name: buttonName,
      ...properties
    });
  } catch (error) {
    console.error('Mixpanel button click tracking error:', error);
  }
};

export const trackFormSubmission = (formName: string, properties?: Record<string, any>) => {
  try {
    mixpanel.track('Form Submitted', {
      form_name: formName,
      ...properties
    });
  } catch (error) {
    console.error('Mixpanel form submission tracking error:', error);
  }
};

export const trackSubscriptionEvent = (planName: string, planType: 'monthly' | 'annual', properties?: Record<string, any>) => {
  try {
    mixpanel.track('Subscription Started', {
      plan_name: planName,
      plan_type: planType,
      ...properties
    });
  } catch (error) {
    console.error('Mixpanel subscription tracking error:', error);
  }
};

export const trackRequestCreated = (requestType: string, properties?: Record<string, any>) => {
  try {
    mixpanel.track('Request Created', {
      request_type: requestType,
      ...properties
    });
  } catch (error) {
    console.error('Mixpanel request creation tracking error:', error);
  }
};

export default mixpanel; 